var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-picture",class:{ 'chat-picture--single-blocked': _vm.users.length === 1 && _vm.users[0].dislike },style:({ height: _vm.h, width: _vm.w })},_vm._l((_vm.avatars),function(avatar,index){return _c('div',{key:avatar.id + '-' + index,class:{ 'chat-picture--blocked': avatar.dislike },style:(avatar.style)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }